import { typedQueryClient, useTypedQuery } from "hooks";
import { AuthKeys } from "modules/Auth/queryKeys";
import { UserAcls } from "modules/Auth/services";

export const useUser = () => useTypedQuery({ queryKey: AuthKeys.user, initialData: null }).data;
export const useUserUpdate = () => (user: UserAcls | null) => typedQueryClient.setQueryData(AuthKeys.user, user);
